export default __webpack_public_path__ + "static/media/forestly-expl-06_DE.0f80ca9d.png";